export enum SupportedDocumentType {
 Word = 'application/msword',
 OpenWord = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
 Excel = 'application/vnd.ms-excel',
 OpenExcel = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
 Csv = 'text/csv',
 Ppt = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
 Png = 'image/png',
 Jpg = 'image/jpg',
 Jpeg = 'image/jpeg',
 Pdf = 'application/pdf',
}
